import { createRouter, createWebHistory } from "vue-router"
const routes = [
    // {
    //     path: "/",
    //     component: () => import("@/views/Login.vue"),
    // },
    {
        path: "/nologin",
        component: () => import("@/views/noLogin.vue"),
    },
     {
        path: "/yunweiDetail",
        component: () => import("@/views/yunweiDetail.vue"),
    },
    //监控记录
    {
        path:'/monitoringRecord',
        component: () => import("@/views/monitoringRecord.vue"),
    },
    //屏幕录制
    {
        path: "/screenRecording",
        component: () => import("@/views/screenRecording.vue"),
    },
     //流媒体地址播放
     {
        path: "/rtsp",
        component: () => import("@/views/rtsp.vue"),
    },
         //流媒体地址播放
         {
            path: "/alarm",
            component: () => import("@/views/alarm.vue"),
        },
    // {
    //     path: "/HVC",
    //     component: () => import("@/views/HVC.vue"),
    // },


]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
})

export default router
